export default {
  methods: {
    closeMembersDropdownList() {
      if (this.entityType) {
        this.$store.dispatch('setCurrentCardIdMemberDropdown', '');
        this.$store.dispatch('setCurrentCardMembersDropdown', {});
        this.$store.dispatch('setHeaderMemberDropdownPosition', {});
      }
    },
  },
  computed: {
    entityType() {
      return this.$store.getters.getCurrentCardIdMemberDropdown;
    },
  },
};
